module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/point02_01_winter-591e06d6617e2aa2a0cdad78900fc2ef.jpg";